import { useSyncExternalStore } from 'react';
import type { ReactPortal } from 'react';
import { createPortal } from 'react-dom';

import { loadingOverlay } from './loadingOverlay';
import styles from './LoadingOverlayHost.module.css';

/**
 * Слой блокирующей загрузки: то, что в Dart делал `EasyLoading.init()`
 * в `appShellBuilder`.
 *
 * `userInteractions = false` из `main.dart` означает, что нажатия не доходят
 * до интерфейса, пока висит индикатор, — за это отвечает сам слой
 * (`pointer-events: auto` на весь экран).
 */

/** CircularProgressIndicator: размер 36 и толщина дуги 4 — как во Flutter. */
const SPINNER_VIEW_BOX = '0 0 36 36';
const SPINNER_CENTER = 18;
const SPINNER_RADIUS = 16;

export function LoadingOverlayHost(): ReactPortal | null {
  const visible = useSyncExternalStore(
    loadingOverlay.subscribe,
    loadingOverlay.getSnapshot,
    loadingOverlay.getSnapshot,
  );

  if (!visible) return null;

  return createPortal(
    <div className={styles.barrier} role="progressbar" aria-busy="true">
      <svg className={styles.spinner} viewBox={SPINNER_VIEW_BOX}>
        <circle
          className={styles.arc}
          cx={SPINNER_CENTER}
          cy={SPINNER_CENTER}
          r={SPINNER_RADIUS}
        />
      </svg>
    </div>,
    document.body,
  );
}
